(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && Shopify.designMode;

  function initReveals(root) {
    root = root || document;
    var reveals = root.querySelectorAll('.pss-reveal:not([data-pss-reveal-init])');
    if (!reveals.length) return;

    reveals.forEach(function (el) {
      el.setAttribute('data-pss-reveal-init', '');
      var delay = el.getAttribute('data-delay');
      if (delay) el.style.setProperty('--pss-reveal-delay', delay + 'ms');

      if (reducedMotion || designMode) {
        el.classList.add('is-visible');
      }
    });

    if (reducedMotion || designMode) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );

    reveals.forEach(function (el) {
      if (!el.classList.contains('is-visible')) {
        observer.observe(el);
      }
    });
  }

  initReveals();

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initReveals(event.target);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initReveals();
  });
})();
